import script from "./Conversation.vue?vue&type=script&setup=true&lang=js"
export * from "./Conversation.vue?vue&type=script&setup=true&lang=js"

import "./Conversation.vue?vue&type=style&index=0&id=f3d4d0c0&lang=css"

const __exports__ = script;

export default __exports__